import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function SaasIndustryPage() {
  return <IndustryDetailPage slug="saas" />;
}